<script setup>
import { initWorkspace } from '@/composables'
initWorkspace()
</script>

<template>
    <slot></slot>
</template>